
import ApiRequest from '@js/utilities/apiRequest.js'
import { errorNotify } from '@js/utilities/bugsnag.js'
import { url } from '@js/utilities/url.js'

export default async function fetchFullTranslations(i18n, store) {
    let params = {}
    if (window.CAMPAIGN_TYPE) {
        params = {
            campaign_type: window.CAMPAIGN_TYPE
        }
    }

    const apiTranslationMessages = await ApiRequest.get(store, url(`/api/translations`), params)
    if (!apiTranslationMessages?.data) {
        console.error('Translations data empty')
        errorNotify('Translations data empty', 'error', 'Translations', { data: apiTranslationMessages })
        return false
    }

    // set locale and locale message
    i18n.global.mergeLocaleMessage(i18n.global.locale, apiTranslationMessages.data)

    window.translationsLoaded = true

    // need to translate on startup as we can't use $t inside the state
    store.commit('translateSortOptions')
    store.commit('translateRtwSortOptions')
    store.commit('addFieldValidationMessages')

    return true
}
